export const SLIDER_RECOMMENDATION_KEY = 'slider-recommendation'

export const ITEM_SLIDER_KEY = 'item-slider'
